import { render } from "./AppointmentsHeader.vue?vue&type=template&id=0e1bb98e&ts=true"
import script from "./AppointmentsHeader.vue?vue&type=script&lang=ts"
export * from "./AppointmentsHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__